import { httpsCallable } from 'firebase/functions';
import { functions } from '../config/firebase';
import { FALLBACK_EUR_RATES } from './minStartupAsk';

/** Live EUR rates, or the built-in fallback when the rate service is down. */
export async function loadExchangeRates(): Promise<Record<string, number>> {
  try {
    const getExchangeRates = httpsCallable(functions, 'getExchangeRates');
    const result = await getExchangeRates({ baseCurrency: 'EUR' });
    const data = result.data as { success?: boolean; rates?: Record<string, number> };
    if (data?.success && data.rates && typeof data.rates.eur === 'number') {
      return data.rates;
    }
  } catch (error) {
    console.error('Exchange rates unavailable, using fallback rates', error);
  }
  return FALLBACK_EUR_RATES;
}
